import type {
  Backgrounds,
  BoxShadows,
  Breakpoints,
  FontSize,
  FontWeight,
  MediaQueries,
  Radii,
  Shadows,
  Spacing,
  ZIndices,
} from "./types";

export const breakpointMap: { [key: string]: number } = {
  xs: 370,
  sm: 576,
  md: 852,
  lg: 968,
  xl: 1080,
  xxl: 1160,
  "2xl": 1536,
};

const breakpoints: Breakpoints = Object.values(breakpointMap).map(
  (breakpoint) => `${breakpoint}px`,
);

export const mediaQueries: MediaQueries = {
  xs: `@media screen and (max-width: ${breakpointMap.xs}px)`,
  sm: `@media screen and (max-width: ${breakpointMap.sm}px)`,
  md: `@media screen and (max-width: ${breakpointMap.md}px)`,
  lg: `@media screen and (max-width: ${breakpointMap.lg}px)`,
  xl: `@media screen and (max-width: ${breakpointMap.xl}px)`,
  xxl: `@media screen and (max-width: ${breakpointMap.xxl}px)`,
  "2xl": `@media screen and (max-width: ${breakpointMap["2xl"]}px)`,
};

export const shadows: Shadows = {
  active: "0px 0px 0px 1px #12FFB8, 0px 0px 4px 8px rgba(31, 199, 212, 0.4)",
  success: "0px 0px 0px 1px #31D0AA, 0px 0px 0px 4px rgba(49, 208, 170, 0.2)",
  warning: "0px 0px 0px 1px #ED4B9E, 0px 0px 0px 4px rgba(237, 75, 158, 0.2)",
  focus: "0px 0px 0px 1px rgba(74, 74, 104, 0.1), 0px 0px 0px 3px #12FFB8",
  box: "1px 4px 5px 0px rgba(208, 213, 221, 0.80)",
  boxDark: "1px 4px 10px 0px rgba(208, 213, 221, 0.40)",
  select: "0 0 64px #00000014, 0 8px 16px #00000029",
};

export const spacing: Spacing = [0, 4, 8, 16, 24, 32, 48, 64];

export const radii: Radii = {
  default: "8px",
  bigger: "12px",
  biggest: "16px",
  smaller: "4px",
  circle: "50%",
};

export const zIndices: ZIndices = {
  dropdown: 10,
  modal: 100,
};

export const backgrounds: Backgrounds = {
  primary:
    "linear-gradient(111.98deg, rgba(255, 255, 255, 0.05) 5%, rgba(0, 0, 0, 0.03) 100%)",
  secondary: "#1D1D26",
  secondaryTransparent: "rgba(29, 29, 38, 0.5)",
  theme: "#FFFFFF",
};

export const boxShadows: BoxShadows = {
  primary: "0 6px 29px 0 rgba(0, 0, 0, 0.07)",
  secondary: "6px 4px 10px rgba(0, 0, 0, 0.102)",
  pagination: "6px 6px 15px -6px rgb(0 0 0 / 7%)",
  select: "0px 1px 2px rgba(85, 104, 125, 0.1)",
  selectTop: "0px -1px 2px rgba(85, 104, 125, 0.1)",
  dashboard: "0px 0px 3px rgba(85, 104, 125, 0.2)",
  referralHeader: "0px 4px 4px 0px #00000040",
};

export const fontSizes: FontSize = {
  xxxl: "1.75rem", // 28px
  xxl: "1.5rem", // 24px
  xl: "1.25rem", // 20px
  l: "1.125rem", // 18px
  m: "1rem", // 16px
  s: "0.875rem", // 14px
  xs: "0.75rem", // 12px
  xxs: "0.625rem", // 10px
};

export const fontWeights: FontWeight = {
  bold: 700,
  semibold: 600,
  medium: 500,
  normal: 400,
  light: 300,
};

export default {
  siteWidth: 1200,
  breakpoints,
  mediaQueries,
  spacing,
  shadows,
  radii,
  zIndices,
  backgrounds,
  boxShadows,
  fontSizes,
  fontWeights,
};
